export const ledHeaderImage = require('assets/images/led-landing/headerLedImage.png');
export const StartNewProjectScreen = require('assets/images/led-landing/StartNewProjectScreen.png');
export const firstStepHIWImage = require('assets/images/led-landing/firstStepHIWImage.jpg');
export const secondStepHIWImage = require('assets/images/led-landing/secondStepHIWImage.jpg');
export const thirdStepHIWImage = require('assets/images/led-landing/thirdStepHIWImage.jpg');
export const tabStep1Image = require('assets/images/led-landing/step1Image.jpg');
export const tabStep2Image = require('assets/images/led-landing/step2Image.jpg');
export const tabStep3Image = require('assets/images/led-landing/step3Image.jpg');
export const tabStep4Image = require('assets/images/led-landing/step4Image.jpg');
export const tabStep5Image = require('assets/images/led-landing/step5Image.jpg');
export const allSetImage = require('assets/images/led-landing/allSetImage.jpg');
export const lastStepImage = require('assets/images/led-landing/lastStepImage.jpg');
export const needEmailImage = require('assets/images/led-landing/needEmailImage.jpg');
export const placeOrderImage = require('assets/images/led-landing/placeOrderImage.jpg');
export const replacementsImage = require('assets/images/led-landing/replacementsImage.jpg');
export const selectionImage = require('assets/images/led-landing/selectionImage.jpg');
export const startProjectImage = require('assets/images/led-landing/startProjectImage.jpg');
